import { render } from "./Ticket_submit.vue?vue&type=template&id=19bcfa39"
import script from "./Ticket_submit.vue?vue&type=script&lang=js"
export * from "./Ticket_submit.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__